// extracted by mini-css-extract-plugin
module.exports = {"two-line-button-card":"two-line-button-card__two-line-button-card___vSh5p"};